import { RolesInvUnidadDTO } from "./RolPersonaUnidadDTO"

export interface PersonaInvDTO{
    idpersona: number
    tipoidentificacion: string
    numeroidentificacion: string
    apellidos: string 
    nombres: string 
    nombreCompleto: string 
    email: string 
    iddecinvuser: number 
    orcid: string 
    hindex: string 
    scopusid: string 
    scholarid: string 
    roles: Array<RolesInvUnidadDTO> 
}

export function VoidPersonaInvDTO(){
    return {
    idpersona: 0,
    tipoidentificacion: '',
    numeroidentificacion: '',
    apellidos: '',
    nombres: '', 
    nombreCompleto: '', 
    email: '', 
    iddecinvuser: 0, 
    orcid: '',
    hindex: '',
    scopusid: '', 
    scholarid: '', 
    roles: []
    }
}